const adapterSocialMedia = {
  APIToForm(data, options){
    let result = options.isFlat ? {} : []

    if (options.isFlat) {
      let obj = {}

      for (let index = 0; index < data.length; index++) {
        const d = data[index];
        if(d.kategoriSosialMedia && d.kategoriSosialMedia !== null){
          obj['link_'+d.kategoriSosialMedia.id] = d.linkSosialMedia
        }
      }

      result = obj
    } else {
      if(data){
        result = data.map(d => {
          return d.kategoriSosialMedia ? {
            id: d.pkSosialMediaId,
            name: d.kategoriSosialMedia.nama?.[0].toLowerCase(),
            link: d.linkSosialMedia
          } : false
        }).filter(d => d && d !== false)
      }
    }

    return result
  },

  formToAPI(data){
    let result = []

    if(data){
      const socialLinks = Object.keys(data).map(k => {
        if(k.includes('link_')){
          return {
            kategoriSosialMedia: parseInt(k.split('link_')[1]),
            linkSosialMedia: data[k],
          }
        }
        return false
      })

      const filtered = socialLinks.filter(s => s.linkSosialMedia ? s.linkSosialMedia.length > 0 : s !== false)
      result = filtered.filter(s => s.linkSosialMedia !== "")

      console.log('adapter social media result:', result)
    }

    console.log('socmed formToAPI result:', result)
    return result
  }
}

export { adapterSocialMedia }
